import React, { useState, useEffect } from "react";
import { CartProduct } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import axios from "axios";

export default function CategoriesProducts() {
    const { t, i18n } = useTranslation();
    const [dataProduct, setDataProduct] = useState([]);
    const [categories, setCategories] = useState([]); // Renamed from setCategory for clarity
    const [brand, setBrand] = useState([]);
    const [subCategory, setSubCategory] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [currentCategory, setCurrentCategory] = useState("");
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [selectedBrand, setSelectedBrand] = useState("");
    const [selectedCapacity, setSelectedCapacity] = useState("");

    // Get category from URL
    useEffect(() => {
        const pathParts = window.location.pathname.split('/');
        const lastPart = pathParts[pathParts.length - 1];
        const decodedCategory = decodeURIComponent(lastPart);
        setCurrentCategory(decodedCategory);
    }, []);

    // Fetch Products
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/products");
                setDataProduct(response.data.products);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    // Fetch Categories
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/categories");
                setCategories(response.data.category);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    // Fetch Subcategories
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/subCategory");
                setSubCategory(response.data.sub_category);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    // Fetch Brands
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/brand");
                setBrand(response.data.brands);
            } catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        };
        fetchData();
    }, []);

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    // Filter products based on selected filters and current category
    const filteredProducts = dataProduct.filter((product) => {
        if (selectedBrand) {
            // If a brand is selected, show all products for that brand, ignoring category and subcategory
            return (
                product.product_brand_name === selectedBrand &&
                (selectedCapacity ? product.product_capacity_array?.includes(selectedCapacity) : true)
            );
        }
        // Otherwise, apply all filters
        const matchesCategory = currentCategory ? product.product_category === currentCategory : true;
        const matchesSubCategory = selectedSubCategory ? product.product_sub_category === selectedSubCategory : true;
        const matchesCapacity = selectedCapacity ? product.product_capacity_array?.includes(selectedCapacity) : true;

        return matchesCategory && matchesSubCategory && matchesCapacity;
    });

    const showData = filteredProducts.map((el, index) => {
        const priceAfterDiscount = (el.product_price * (1 - el.product_price_discount / 100)).toFixed(2);
        const inventoryClass = el.product_stock_available === 0 ? "text-red-500" : "text-[#18AB00]";
        const isHovered = hoveredIndex === index;

        const productName = getLocalizedText({ A: el.product_name_A, E: el.product_name_E });
        const productDesc = getLocalizedText({ A: el.product_desc_A, E: el.product_desc_E });

        return (
            <Link
                key={index}
                to={`/productdetails/${el.product_id}`}
                className="h-315 pr-grid cursor-pointer flex flex-col w-[250px] h-[416px] rounded-md shadow-md outline outline-[2px] outline-solid relative"
                style={{ outlineColor: "#eee" }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
            >
                <div className="h-125 h-[218px] w-full relative">
                    <img className="w-full h-full rounded-t-md object-cover" src={`https://laravel-api.aj-mart.com/storage/app/public/${el.product_main_img}`} alt={el.product_name_E} />
                    <div className="dis-grid w-10 h-10 bg-[#1485a6] rounded-full text-white font-bold flex items-center justify-center absolute top-[10px] right-[10px]">
                        {(el.product_price_discount * 1).toFixed(0)}%
                    </div>
                </div>
                <div className="h-[2px] bg-[#666666]"></div>
                <div className="p-[1rem] py-[10px] flex flex-col gap-[10px] p-4 pb-5">
                    <div className="flex items-center justify-between">
                        <div className="name-grid text-[16px] font-bold">
                            {t(`${productName.length > 50 ? productName.substring(0, 50) + "..." : productName}`)}
                        </div>
                        <div className="new-grid w-[60px] h-[19px] bg-[#1485a6] text-white capitalize font-bold rounded-tr-[100px] rounded-bl-[100px] flex items-center justify-center text-[10px]">
                            {t(`${el.product_status}`)}
                        </div>
                    </div>
                    <p className="text-[10px] text-[#666666]">
                        {t(`${productDesc.length > 75 ? productDesc.substring(0, 75) + "..." : productDesc}`)}
                    </p>
                    <div className="flex justify-between">
                        <div className="flex flex-col gap-[5px]">
                            <span className="font-bold font-12">
                                {priceAfterDiscount} <span>{t("JOD")}</span>
                            </span>
                            <span className="line-through text-red-500 font-12">
                                {el.product_price} <span>{t("JOD")}</span>
                            </span>
                        </div>
                        <div className={`d-none font-bold capitalize text-[14px] ${inventoryClass}`}>
                            {t(`In stock: ${el.product_stock_available}`)}
                        </div>
                       
                    </div>
                </div>
                <Link
                    to={`/productdetails/${el.product_id}`}
                    className={`bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] absolute bottom-0 left-0 right-0 transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"}`}
                >
                    <CartProduct />
                    {t("Add To Cart")}
                </Link>
            </Link>
        );
    });

    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="text-[35px] font-bold text-white">{t("All Product")}</div>
                    <div className="flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{currentCategory || t("All Product")}</div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container f-col flex justify-between gap-[50px]">
                    <div className="w-100 w-[100%] flex flex-col justify-between gap-10">
                        <div className="flex items-center gap-[12px] flex-wrap">
                            {/* Categories */}
                            <div className="w-[24%] flex flex-col gap-[5px]">
                                <label className="text-[#1485a6] font-bold">{t("Categories")}</label>
                                <select
                                    className="w-full p-[8px] rounded-[4px] outline-none border border-[#1485a6] bg-transparent text-[#8a909a]"
                                    value={currentCategory}
                                    onChange={(e) => setCurrentCategory(e.target.value)}
                                >
                                    <option value="">{t("Show All Categories")}</option>
                                    {categories.map((item) => (
                                        <option
                                            key={item.category_id}
                                            value={item.category_name_E}
                                        >
                                            {getLocalizedText({
                                                A: item.category_name_A,
                                                E: item.category_name_E,
                                            })}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* Sub Categories */}
                            <div className="w-[24%] flex flex-col gap-[5px]">
                                <label className="text-[#1485a6] font-bold">{t("Sub Categories")}</label>
                                <select
                                    className="w-full p-[8px] rounded-[4px] outline-none border border-[#1485a6] bg-transparent text-[#8a909a]"
                                    value={selectedSubCategory}
                                    onChange={(e) => setSelectedSubCategory(e.target.value)}
                                >
                                    <option value="">{t("Show All Sub Categories")}</option>
                                    {subCategory.map(item => (
                                        <option key={item.sub_category_id} value={item.sub_category_name_E}>
                                            {getLocalizedText({
                                                A: item.sub_category_name_A,
                                                E: item.sub_category_name_E,
                                            })}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* Brand */}
                            <div className="w-[24%] flex flex-col gap-[5px]">
                                <label className="text-[#1485a6] font-bold">{t("Brand")}</label>
                                <select
                                    className="w-full p-[8px] rounded-[4px] outline-none border border-[#1485a6] bg-transparent text-[#8a909a]"
                                    value={selectedBrand}
                                    onChange={(e) => setSelectedBrand(e.target.value)}
                                >
                                    <option value="">{t("Show All Brands")}</option>
                                    {brand.map(item => (
                                        <option key={item.brand_id} value={item.brand_name}>
                                            {item.brand_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* Capacity */}
                            <div className="w-[24%] flex flex-col gap-[5px]">
                                <label className="text-[#1485a6] font-bold">{t("Capacity")}</label>
                                <select
                                    className="w-full p-[8px] rounded-[4px] outline-none border border-[#1485a6] bg-transparent text-[#8a909a]"
                                    value={selectedCapacity}
                                    onChange={(e) => setSelectedCapacity(e.target.value)}
                                >
                                    <option value="">{t("Show All Capacities")}</option>
                                    <option value="64">64 GB</option>
                                    <option value="128">128 GB</option>
                                    <option value="256">256 GB</option>
                                    <option value="512">512 GB</option>
                                    <option value="1">1 T</option>
                                </select>
                            </div>
                        </div>
                        <div className="g-10 w-[100%] flex flex-wrap gap-[20px] just-center">
                            {showData.length > 0 ? showData : <p>{t("No products match the selected filters.")}</p>}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}